import { render, staticRenderFns } from "./verifyPoints.vue?vue&type=template&id=ee46b440"
import script from "./verifyPoints.vue?vue&type=script&lang=js"
export * from "./verifyPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee46b440')) {
      api.createRecord('ee46b440', component.options)
    } else {
      api.reload('ee46b440', component.options)
    }
    module.hot.accept("./verifyPoints.vue?vue&type=template&id=ee46b440", function () {
      api.rerender('ee46b440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/verifition/Verify/verifyPoints.vue"
export default component.exports